import { render, staticRenderFns } from "./add-csv.vue?vue&type=template&id=2d1128ea"
import script from "./add-csv.vue?vue&type=script&lang=js"
export * from "./add-csv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports